/*
 * `URLSearchParams` happily serializes an empty value, which turns an unset filter into a real
 * query parameter. The fleet inventory endpoint rejects `category=` with a 422 because the empty
 * string is not a known category, so blank values have to be dropped before serializing.
 *
 * `0` and `false` are values rather than blanks - `start: 0` has to survive.
 */
export const stripBlankParams = (queryParams = {}) => {
	return Object.entries(queryParams).reduce((params, [key, value]) => {
		if (value === undefined || value === null || String(value).trim() === '') {
			return params;
		}

		return { ...params, [key]: value };
	}, {});
};

export default { stripBlankParams };
